import(/* webpackMode: "eager" */ "/home/node/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/IRANSansMobile(FaNum).woff2\"}],\"variableName\":\"myFont\"}");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/node/app/src/app/providers.tsx");
